import { useState, useEffect } from "react";
import { MIL882EMatrix, getMatrix } from "../../helpers/riskHelper";

/**
 * Custom hook for loading a risk matrix with fallback to MIL882E
 * @param {Object} project The project containing a riskMatrix property
 * @param {Object} toast The toast notification object
 * @returns {Object} The risk matrix object
 */
const useRiskMatrix = (project, toast) => {
  const [riskMatrix, setRiskMatrix] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRiskMatrix = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        if (project && project.riskMatrix) {
          try {
            const matrix = await getMatrix(project.riskMatrix);

            if (!matrix) {
              console.warn(
                `Risk matrix ${project.riskMatrix} not found, using default`
              );
              setRiskMatrix(MIL882EMatrix);
              return;
            }

            setRiskMatrix(matrix);
          } catch (error) {
            console.error("Error loading risk matrix:", error);
            setError("Failed to load risk matrix. Using default matrix instead.");

            if (toast) {
              toast({
                variant: "destructive",
                title: "Error loading risk matrix",
                description:
                  "Failed to load risk matrix. Using default matrix instead.",
              });
            }

            // Fallback to default matrix
            setRiskMatrix(MIL882EMatrix);
          }
        } else if (project) {
          // Use default matrix if none specified
          console.warn("No risk matrix specified for project, using default");
          setRiskMatrix(MIL882EMatrix);
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadRiskMatrix();
  }, [project, toast]);

  return { riskMatrix, isLoading, error };
};

export default useRiskMatrix;